module.exports = __webpack_public_path__ + "img/l-hd.9a2cac09.jpg";